import { connect } from "react-redux";

import Root from "./Root";

import {init, checkIfAppIsInitialized, hideErrorNotification} from "../../store/actions";

const mapStateToProps = state => ({
  isInitialized: state.isInitialized,
  isPreinitialized: state.pendingRequests === 0,
  showLightVersion: state.showLightVersion,
  searchRouteError: state.searchRouteError,
  isRouteSearchFailed: state.isRouteSearchFailed
});

const mapDispatchToProps = dispatch => ({
  checkIfAppIsInitialized: () => dispatch(checkIfAppIsInitialized()),
  init: () => dispatch(init()),
  hideErrorNotification: () => dispatch(hideErrorNotification())
});

export default connect(mapStateToProps, mapDispatchToProps)(Root);
